import type { Action } from 'redux';

export const FLIPPER_HYDRATE = 'FLIPPER_HYDRATE';

export function hydrate(): HydrateAction {
  return {
    type: FLIPPER_HYDRATE,
  };
}

export type HydrateAction = Action<typeof FLIPPER_HYDRATE>;
